export const shadows = [
  "0px 0px 2px rgba(0, 0, 0, 0.1), 0px 5px 32px rgba(0, 0, 0, 0.1)",
];
